<template>
    <div v-loading="loading">
        <div class="head">
            <!-- 刷新按钮 -->
            <el-button type="primary" size="small" icon="el-icon-refresh" @click="getData">{{
                $t('lang.terminalList.refresh') }}</el-button>
            <span>({{ $t('lang.terminalList.plsupdate') }})</span>
        </div>
        <el-table :data="tableData" style="width: 100%">
            <!-- 序号 -->
            <el-table-column type="index" width="100" align="center"
                :label="$t('lang.terminalList.index')"></el-table-column>
            <!-- IP地址 -->
            <el-table-column prop="ip" :label="$t('lang.terminalList.ip')" align="center">
                <template slot-scope="scope">
                    <span class="fontStyle">{{ scope.row.ip }}</span>
                </template>
            </el-table-column>
            <!-- mac -->
            <el-table-column prop="mac" :label="$t('lang.terminalList.mac')" align="center">
                <template slot-scope="scope">
                    <span class="fontStyle">{{ scope.row.mac }}</span>
                </template>
            </el-table-column>
            <!-- network -->
            <el-table-column prop="network" :label="$t('lang.terminalList.networkInterface')" align="center">
                <template slot-scope="scope">
                    <span class="fontStyle">{{ scope.row.network }}</span>
                </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column :label="$t('lang.terminalList.operate')" align="center"
                v-if="Permission.indexOf(288) != -1">
                <template slot-scope="scope">
                    <!-- <el-button type="primary" size="mini" @click="open(scope.row.ip)">访问</el-button> -->
                    <el-button type="primary" size="mini" @click="connect(scope.row.ip)">{{
                        $t('lang.terminalList.directAccess') }}</el-button>
                    <el-button type="primary" size="mini" @click="open(scope.row.ip)">{{
                        $t('lang.terminalList.configAccess') }}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog :title="$t('lang.terminalList.connectTips')" :visible.sync="connectDialog" width="30%"
            :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
            <p>{{ $t('lang.terminalList.stopClose') }}</p>
            <el-form :model="connectInfo" v-loading="connectLoading">
                <el-form-item :label="$t('lang.terminalList.portToAccess')" prop="port">
                    <el-input v-model="connectInfo.port" size="mini"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.terminalList.urlToAccess')" prop="port">
                    <el-input v-model="connectInfo.path" size="mini"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.webssh.SelectRoute')" prop="ssH_password">
                    <el-select v-model="connectInfo.networkLine" size="mini">
                        <el-option :label="$t('lang.webssh.DEFAULT')" value="DEFAULT"></el-option>
                        <el-option :label="$t('lang.ConfigSetting.ChinaMobile')" value="CHINA_MOBILE"></el-option>
                        <el-option :label="$t('lang.ConfigSetting.ChinaTelecom')" value="CHINA_TELECOM"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" type="primary" @click="connect()">{{
                        $t('lang.terminalList.EstablishConnection')
                        }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { getDeviceTerminalList, getDeviceMqttStatus, updateConfig, listConfig, getNetworkInfo } from "@/api/configurationlist";
import { getWebsshUrl, removeDeviceIp, logError, pingIp } from "@/api/particulars";
import { SetDeviceIp, removeWebCookie, SetDevicePort } from "@/cookie/cookie"
import { getPermission } from '@/cookie/cookie'
export default {
    name: "",
    props: ['did', 'dsn', 'time', 'activeName'],
    data() {
        return {
            Permission: [],
            timer: null,
            tableData: [],
            loading: true,
            connectInfo: {
                port: '80',
                hostname: '',
                path: '/',
                networkLine:'DEFAULT'
            },
            connectDialog: false,
            window_did: undefined,
            window_dsn: undefined,
            connectLoading: false,
            count: 0,
            pingStatus: false,
            redirectInfo: {
                index: [0],
                section: "redirect",
                config: "firewall",
                action: 1,
                options: {
                    dest: "lan",
                    target: 'DNAT',
                    name: 'RemoteTerminalAccess',
                    src: 'wan',
                    dest_ip: '',
                    family: 'ipv4',
                    src_dport: '8001',
                    dest_port: '80',
                    enabled: '1'
                },
                lists: {
                    proto: ['tcp', 'udp']
                }
            },
            connectTimer: null
        };
    },
    methods: {
        async getData() {
            this.loading = true
            await getDeviceTerminalList({
                "cmd": 58,
                SN: this.dsn,
                "mess": {},
                "did": this.did,
            }).then(res => {
                if (res.data.code == 0) {
                    this.tableData = res.data.data.mess
                } else {
                    this.$message({
                        message: "获取终端列表失败",
                        type: 'error'
                    })
                }
                this.loading = false
            })
            this.Permission = getPermission();
        },
        clearTimer() {
            if (this.timer) {
                clearInterval(this.timer)
            }
        },
        open(ip) {
            this.connectDialog = true
            this.redirectInfo.options.dest_ip = ip
        },
        async handleClose() {
            await this.unconnect()
            this.connectDialog = false
        },
        async initWanZone() {
            const resp = await listConfig(this.window_dsn, this.window_did, [
                {
                    section: "zone",
                    config: "firewall",
                    options: [
                        { option: "name" },
                    ],
                    lists: [
                        {
                            list: 'network'
                        }
                    ]
                }
            ])
            let zone = resp.data.data.mess[0].s_objects;
            let wanNetwork = [], isExist = false, index = 0;
            if (zone && zone.length > 0) {
                zone.forEach(item => {
                    if (item.options.name == "wan") {
                        wanNetwork = item.lists.network;
                        isExist = true;
                        index = item.index;
                    }
                })
            }
            if (!isExist) {
                this.$message({
                    message: "请先在防火墙添加wan规则",
                    type: 'error'
                })
                throw new Error("请先在防火墙添加wan规则")
            }
            if (!wanNetwork.includes('rterm')) {
                wanNetwork = [...wanNetwork, 'rterm']
                const resp2 = await updateConfig(this.window_dsn, this.window_did, [
                    {
                        section: "zone",
                        config: "firewall",
                        action: 0,
                        index: [index],
                        server: 'firewall',
                        lists: {
                            network: wanNetwork
                        }
                    }
                ])
                if (resp2.data.data.mess != 0) {
                    throw new Error("添加wan规则失败")
                }
            }
        },
        async getProtForwards() {
            const resp = await listConfig(this.window_dsn, this.window_did, [
                {
                    section: "redirect",
                    config: "firewall",
                    options: [
                        { option: "name" },
                    ]
                }
            ])
            let redirects = resp.data.data.mess;
            if (redirects.length == 0) {
                this.redirectInfo.index = [0];
                this.redirectInfo.action = 1;
            } else {
                redirects[0].s_objects.forEach(item => {
                    if (item.options.name == "RemoteTerminalAccess") {
                        this.redirectInfo.index = [item.index];
                        this.redirectInfo.action = 0;
                    }
                })
            }
        },
        async enableProtForwards() {
            const resp = await updateConfig(this.window_dsn, this.window_did, [
                this.redirectInfo
            ])
            if (resp.data.data.mess == 0) {
                this.$message.success('操作成功');
            } else {
                this.$message.error('操作失败')
            }
        },
        async disableProtForwards() {
            this.redirectInfo.action = 0;
            this.redirectInfo.options.enabled = '0';
            const resp = await updateConfig(this.window_dsn, this.window_did, [
                this.redirectInfo
            ])
            if (resp.data.data.mess == 0) {
                this.$message.success('操作成功')
                this.redirectDialog = false
            } else {
                this.$message.error('操作失败')
            }
        },
        async connect(host) {
            this.connectLoading = true;
            if (host) {
                this.connectInfo.hostname = host;
                this.connectInfo.port = "80";
                this.connectInfo.path = "/";
                this.loading = true;
                this.redirectInfo.options.dest_ip = host;
            }
            if (this.connectInfo.port === '') {
                return this.$message.error('请输入端口号')
            }
            this.redirectInfo.options.dest_port = this.connectInfo.port;
            await this.initWanZone();
            await this.getProtForwards();
            await this.enableProtForwards();
            try {
                const res = await getDeviceMqttStatus(this.window_dsn)
                if (!res.data.online) {
                    this.$message.error("设备MQTT不在线");
                    this.connectLoading = false;
                    return
                }
            } catch (e) {
                this.$message.error("设备MQTT不在线");
                this.connectLoading = false;
                return
            }
            try {
                await this.getIp()
            } catch (e) {
                this.$message.error('获取终端地址失败')
                return
            }
            if (this.connectTimer) {
                clearInterval(this.connectTimer)
            } else {
                this.connectTimer = setInterval(() => {
                    if (!this.pingStatus) {
                        this.pingStatus = true;
                        pingIp({
                            deviceSN: this.window_dsn,
                            did: this.window_did,
                            ip: this.connectInfo.hostname
                        }).then(res => {
                            if (res.data.code === 0) {
                                clearInterval(this.connectTimer)
                                this.connectTimer = null;
                                this.connectLoading = false;
                                SetDeviceIp(this.connectInfo.hostname)
                                SetDevicePort('8001');
                                let { href } = this.$router.resolve({
                                    path: `/web/${this.window_did}/${this.window_dsn}`,
                                    query: { ip: this.connectInfo.hostname, port: '8001', path: this.connectInfo.path },
                                });
                                window.open(href, "_blank");
                                this.count = 0;
                            }
                        }).finally(async () => {
                            await logError({
                                deviceSN: this.window_dsn,
                                did: this.window_did,
                                ip: this.connectInfo.hostname,
                            })
                            this.count++;
                            this.pingStatus = false;
                            this.loading = false;
                            if (this.count > 3) {
                                clearInterval(this.connectTimer)
                                this.connectTimer = null;
                                this.$message.error('连接隧道失败，请检查网络或设备状态')
                                this.connectLoading = false
                                this.count = 0
                            }
                        })
                    }
                }, 3000);
            }
        },
        getIp() {
            return new Promise((resolve, reject) => {
                getWebsshUrl({
                    deviceSN: this.window_dsn,
                    did: this.window_did,
                    networkLine:this.connectInfo.networkLine
                }).then(res => {
                    if (res.data.code == 0) {
                        this.connectInfo.hostname = res.data.data
                    } else {
                        this.$message.error(res.data.error_message)
                    }
                    resolve()
                }).catch(err => { reject() })
            })
        },
        async unconnect() {
            removeWebCookie()
            if (this.connectInfo.hostname !== '') {
                if (this.connectTimer) {
                    clearInterval(this.connectTimer)
                    this.connectTimer = null;
                    this.connectReady = false;
                }
                try {
                    this.connectLoading = true
                    await this.disconnectHandler();
                    this.connectLoading = false
                } catch {
                    this.$message({
                        showClose: true,
                        message: this.$t('lang.devicelist.disbad'),
                        type: "error"
                    });
                }
            }
        },
        async disconnectHandler() {
            let ip = this.connectInfo.hostname;
            this.connectInfo.hostname = '';
            const res = await removeDeviceIp({
                ip,
                deviceSN: this.window_dsn,
                did: this.window_did
            })
            if (res.status !== 200) {
                this.$message.error(res.data.message);
            }
        },
    },
    mounted() {
        this.getData()
        this.window_did = this.did;
        this.window_dsn = this.dsn;
    },
    watch: {
        activeName: {
            handler: function (val, oldVal) {
                if (val == 'terminalList') {
                    if (this.timer) {
                        clearInterval(this.timer)
                    }
                    this.getData()
                    this.timer = setInterval(() => {
                        this.getData()
                    }, this.time)
                } else {
                    clearInterval(this.timer)
                }
            },
            deep: true
        }
    },
    deactivated() {
        this.tableData = []
    },
    beforeDestroy() {
        this.unconnect();
    }
};
</script>
<style scoped>
.head span {
    margin-left: 20px;
    color: #aaa;
}
</style>